import CrowdfundingPropertyError from './CrowdfundingPropertyError';
class InvalidId extends CrowdfundingPropertyError {
    crowdfundingPropertyId;
    constructor(crowdfundingPropertyId, options) {
        super('The crowdfunding property id is invalid', options);
        this.crowdfundingPropertyId = crowdfundingPropertyId;
    }
}
export default InvalidId;
